/**
 * presetRouteCore.js — КУДА ИДЁТ ОРГАННАЯ КНОПКА 3D: В ПРЕСЕТ ИЛИ В МАСКУ.
 * [12.0.26]
 *
 * Чистый модуль, без DOM и Cornerstone — под тестами. Проводка —
 * ui/sidebarBindings.js (обе панели кнопок: левая .sl-vrt-btn и чипы).
 *
 * Откуда взялось. Владелец прислал одиннадцать скринов органных пресетов:
 * «абсолютно нерабочие, не показывают то, о чём заявляют». Девять из
 * одиннадцати делали непрозрачными кожу и мышцы — это исправлено в самих
 * кривых (presets3d.ts). Но у части органов беда не в кривой, а в числах:
 *
 *   · поджелудочная — в любую фазу то же число, что у селезёнки, стенки
 *     кишки и желудка (панкреатическая 100–130 HU, портальная 90–110);
 *   · печень на артериальной фазе — 60–80 HU, вровень с мышцей 60–70; на
 *     нативе — 45–65.
 *
 * Такие органы порогом не выделить вообще, а режим «Точно (по маске)» с
 * 12.0.18 по умолчанию выключен — врач нажимал кнопку и получал брюшную
 * стенку. Поэтому для них кнопка идёт в маску сама, без тумблера. Если маска
 * не получилась (нет модели, сеть не нашла орган) — вызывающий честно
 * говорит об этом и применяет пресет по плотности.
 *
 * EXPORTS: ВСЕГДА_МАСКА, МАСКА_ПО_ФАЗЕ, ПОДСКАЗКИ, маршрутКнопки, фазаДляПресета
 */

/** Кнопки, которые плотностью не работают никогда. */
export const ВСЕГДА_МАСКА = Object.freeze({
  'custom-16-ct-pancreas':
    'поджелудочную плотностью не выделить: в любую фазу у неё то же число, что у селезёнки и стенки кишки',
  'custom-21-ct-upper-abdomen-organs':
    'в наборе поджелудочная, а её плотностью не выделить',
});

/** Кнопки, которые плотностью не работают в отдельных фазах. */
export const МАСКА_ПО_ФАЗЕ = Object.freeze({
  'custom-01-ct-liver': Object.freeze({
    фазы: Object.freeze(['native', 'arterial', 'pulmonary']),
    причина: 'печень вне портальной фазы (60–80 HU) вровень с мышцей — порогом её не отделить',
  }),
});

/** Кнопки, про которые врачу надо сказать правду при нажатии. */
export const ПОДСКАЗКИ = Object.freeze({
  'custom-13-ct-bronchi-lumen':
    'Бронхи: пресет для взгляда изнутри трахеи (виртуальная бронхоскопия). Снаружи он покажет кожу — '
    + 'воздух в бронхах той же плотности, что вокруг тела. Дерево бронхов снаружи так не показать',
  'fetus':
    'Плод 3D: показывает окостеневший скелет плода сквозь ткани матери. Кости матери тоже в кадре; '
    + 'на исследовании без беременности это просто скелет',
});

/**
 * Фаза контрастирования для правил пресетов — из решения анализатора
 * качества (studyQualityAnalyzer: native / arterial / venous / delayed /
 * pulmonary / contrast). «venous» и «delayed» для печени — то же, что
 * портальная: паренхима уже 100+ HU. Неизвестное — null.
 */
export function фазаДляПресета(фазаАнализатора) {
  const ф = String(фазаАнализатора || '').toLowerCase();
  if (['native', 'arterial', 'pulmonary'].includes(ф)) return ф;
  if (['venous', 'portal', 'delayed', 'nephrographic', 'excretory'].includes(ф)) return 'portal';
  if (ф === 'contrast') return 'contrast';
  return null;
}

/**
 * Куда вести нажатие.
 *
 * @param {object} с
 * @param {string} с.ключ — data-render-preset кнопки (или cs3d, если набор по нему)
 * @param {boolean} с.тумблер — включён ли «Точно (по маске)»
 * @param {boolean} с.естьНабор — заведён ли для кнопки набор органов (organIsolate3D.НАБОРЫ)
 * @param {string|null} [с.фаза] — результат фазаДляПресета
 * @returns {{путь:'маска'|'плотность', сам?:boolean, причина?:string, подсказка?:string}}
 */
export function маршрутКнопки({ ключ, тумблер, естьНабор, фаза } = {}) {
  const к = String(ключ || '');
  if (естьНабор) {
    if (тумблер) return { путь: 'маска', сам: false };
    if (ВСЕГДА_МАСКА[к]) return { путь: 'маска', сам: true, причина: ВСЕГДА_МАСКА[к] };
    const поФазе = МАСКА_ПО_ФАЗЕ[к];
    if (поФазе && фаза && поФазе.фазы.includes(фаза)) return { путь: 'маска', сам: true, причина: поФазе.причина };
  }
  const подсказка = ПОДСКАЗКИ[к];
  return подсказка ? { путь: 'плотность', подсказка } : { путь: 'плотность' };
}
